<span (click)="clicked()" class="primary-color logoutColor">{{label}}</span>